import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useComments } from '../hooks/useComments';
import CommentList from '../components/CommentList';
import { useAuth } from '../hooks/useAuth';
import CommentForm from '../components/CommentForm';

export default function Discussion() {
  const { ideaId, commentId } = useParams();
  const { user } = useAuth();
  const { 
    comments, 
    loading, 
    error,
    addComment,
    updateComment,
    deleteComment,
    canDeleteComment
  } = useComments(ideaId || '', '');

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[200px]">
        <div className="w-8 h-8 border-4 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-4xl mx-auto p-6 bg-red-50 border border-red-200 rounded-lg text-red-700">
        {error}
      </div>
    );
  }

  const currentDiscussion = comments.find(c => c.id === commentId);
  if (!currentDiscussion) {
    return (
      <div className="max-w-4xl mx-auto p-6 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-700">
        Discussion not found
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-6">
        <Link 
          to={`/idea/${ideaId}`}
          className="inline-flex items-center gap-2 text-indigo-600 hover:text-indigo-800"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Idea
        </Link>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-bold mb-6">Discussion</h2>
        
        <CommentList
          comments={[]}
          currentDiscussion={currentDiscussion}
          onUpdateComment={updateComment}
          onDeleteComment={deleteComment}
          onAddComment={addComment}
          canDeleteComment={canDeleteComment}
          ideaAuthorId={currentDiscussion.user.id}
          isDiscussionView={true}
        />

        {user && (
          <div className="mt-8 pt-6 border-t">
            <h3 className="text-lg font-semibold mb-4">Add a Reply</h3>
            <CommentForm 
              onSubmit={(content) => addComment(content, currentDiscussion.id)}
            />
          </div>
        )}
      </div>
    </div>
  );
}